import api from '@/core/services/api';
import { toDrupalRequest } from '@/core/helpers';

export default {
    async fetchActiveAlerts({ commit, getters }) {
        // Only ever check once per session - a fresh login/app boot resets this and re-checks.
        if (getters.alertsChecked) {
            return;
        }
        commit('setAlertsChecked', true);

        try {
            const response = await api.get(toDrupalRequest('core/urgent-message'));
            const content = typeof response === 'string' ? response.trim() : '';

            commit('setUrgentAlertContent', content || null);

            if (content) {
                // Show the popup automatically for this login - it stays available afterwards
                // via the notifications bell (see getters.hasUrgentAlert) for the rest of the session.
                commit('setActiveModal', 'UrgentAlert');
            }
        } catch (error) {
            console.log('error fetching urgent alerts: ', error);
        }
    },
};
